import apiClient from '../client';
import {
  BASE_ENDPOINTS,
  SERVICES,
  VERSIONS,
  RESOURCES
} from '../common/constants';

// Define the base endpoint for export
const EXPORT_BASE = BASE_ENDPOINTS.createEndpoint(
  SERVICES.DIGITIZATION,
  VERSIONS.V1,
  RESOURCES.EXPORT,
  false // No tenant ID in the base URL
);

// Fetch Export Logs
export const fetchExportLogs = (cursor, limit, exportKey, filters = {}) => {
  return apiClient.post(`${EXPORT_BASE}/export_log_report`, {
    cursor,
    limit,
    exportKey,
    filters
  });
};

// Generate Export Log
export const generateExportLog = (exportKey, filters = {}) => {
  return apiClient.post(`${EXPORT_BASE}?export_key=${exportKey}`, {
    filters
  });
};

// Download Export Log
export const downloadExportFile = async logId => {
  const response = await apiClient.get(
    `${EXPORT_BASE}/download?log_id=${logId}`
  );
  return response.data;
};
